import { ScheduleI } from '~src/interfaces/schedule.interface';
import { SessionUserI } from '~src/interfaces/session.types';
import { ownerToSegment } from '~src/modules/okrs/manageObjectives/shared/utils';

export function getDefaultSchedule(user: SessionUserI, surveyId: string): ScheduleI {
  return {
    id: '',
    surveyId,
    active: false,
    selfAssessment: false,
    anonymous: false,
    isAnonymousManagerAnswerVisible: false,
    share: [ownerToSegment(user)],
    ask: [],
    title: null,
    about: [],
    shareWithSubject: false,
    shareWithManagers: false,
    shareWithManagersLevels: 0,
    attributesVisibility: false,
    showInHeatmapToprow: false,
    startDate: null,
    dueDate: null,
    overdueAnswers: false,
    reminder: null,
    repetition: null,

    startMail: true,
    repetitionMail: true,
    reminderMail: true,
    selfSelectionMail: true,
    managersSelectionMail: true,

    wasStarted: false,
    selfSelection: false,
    managersSelection: false,

    askManagersOfAbouts: false,
    askManagersOfAsks: false,
    askTeamMembersOfAsks: false,
    askTeamMembersOfAbouts: false,

    customSelectors: [],
  };
}
